import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import Header from '@/components/layout/Header.tsx';
import { Sidebar } from '@/components/layout/Sidebar.tsx';
import { Footer } from '@/components/layout/Footer.tsx';
import { HeroSection } from '@/components/sections/HeroSection.tsx';
import { FeaturedProducts } from '@/components/sections/FeaturedProducts.tsx';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        {siteData.canonical && <link rel="canonical" href={siteData.canonical} />}
        
        {/* Open Graph tags */}
        <meta property="og:title" content={siteData.title} />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:url" content={siteData.canonical || window.location.href} />
        <meta property="og:site_name" content={siteData.siteName || siteData.title} />
        <meta property="og:type" content={siteData.ogType || "website"} />
        
        {/* Twitter Card tags */}
        <meta name="twitter:card" content={siteData.twitterCard || "summary_large_image"} />
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:description" content={siteData.description} />
        
        {/* Additional SEO meta tags */}
        <meta name="robots" content="max-image-preview:large" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        
        <div className="flex flex-1">
          <Sidebar />
          
          <main className="flex-1">
            <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
              <div className="px-4 py-6 sm:px-0">
                <HeroSection />
                <FeaturedProducts />
              </div>
            </div>
          </main>
        </div>
        
        <Footer />
      </div>
    </>
  );
}